export { UsernameColor, UsernameSize } from './username.component';
